type SectionTitleBadgeProps = {
  children: React.ReactNode;
  className?: string;
};

export default function SectionTitleBadge({ children, className = "" }: SectionTitleBadgeProps) {
  return (
    <div className={`mx-auto w-fit rounded-[1.6rem] border-2 border-[#2d2729] bg-white px-10 py-5 text-center text-3xl font-extrabold text-[#ffc64a] shadow-[-14px_14px_0_#262124] md:text-5xl ${className}`}>
      {children}
    </div>
  );
}
